enum AlignerMaterial {
  'TruGEN' = 'TruGEN',
  'TruGEN_XR' = 'TruGEN XR',
}

export { AlignerMaterial }
